import { useEffect, useRef, useState } from "react";
import Icon from "../../YourAIAgents/components/components/icon";
import { phaseForElapsed } from "../utils/waitingMessages";

const PHASE_CHECK_INTERVAL_MS = 3000;

const RotatingWaitMessage = ({ fallbackText = "Selecting an Agent..." }) => {
  const startRef = useRef(Date.now());
  const [, setTick] = useState(0);
  const pickedRef = useRef({});

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), PHASE_CHECK_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  const phase = phaseForElapsed(Date.now() - startRef.current);
  const messages = phase?.messages || [];

  let text = fallbackText;
  if (messages.length) {
   
    if (pickedRef.current[phase.key] == null) {
      pickedRef.current[phase.key] = Math.floor(Math.random() * messages.length);
    }
    text = messages[pickedRef.current[phase.key]];
  }

  return (
    <div className="flex justify-start gap-3 items-center mb-4">
      <Icon id="animatedSparkels" />
      <p
        key={text}
        className="text-[12px] m-0"
        style={{ animation: "rwmFadeIn 0.4s ease-in" }}
      >
        {text}
      </p>
      <style>{`@keyframes rwmFadeIn { from { opacity: 0 } to { opacity: 1 } }`}</style>
    </div>
  );
};

export default RotatingWaitMessage;
